import type { GQL_ID, NestedFilter } from '@@partner:graphql/types'
import type { FilterConfig, CustomFilterRenderProps } from '@components/common/filter/FilterConfig'

import React, { useCallback } from 'react'
import { Tag } from 'rsuite'
import FilterPanel from '@components/common/filter/FilterPanel'
import { createFilter } from '@components/common/filter/FilterConfig'
import { getSearchableBannersStatuses, prepareBannersFilter } from '@@partner:helpers/banner'
import BannerTypesFilter from './BannerTypesFilter'

export interface BannersFiltersType {
  name?: string
  typeIds: GQL_ID[]
  statuses: number[]
  activeFrom?: { from?: number; to?: number }
  activeUntil?: { from?: number; to?: number }
}

export interface BannersFilterProps {
  onFilterChanged: (filters: NestedFilter) => void
}

const AVAILABLE_BANNER_STATUSES = getSearchableBannersStatuses()

const defaultFilter: BannersFiltersType = {
  name: undefined,
  typeIds: [],
  statuses: [],
  activeFrom: undefined,
  activeUntil: undefined
}

const filterConfig: FilterConfig[] = [
  createFilter.text('name', 'Название'),
  createFilter.custom(
    'typeIds',
    'Типы баннеров',
    ({ value, onChange }: CustomFilterRenderProps) => (
      <BannerTypesFilter
        value={value || []}
        onChange={onChange}
      />
    ),
    { valueType: 'string[]' }
  ),
  createFilter.multiselect(
    'statuses',
    AVAILABLE_BANNER_STATUSES,
    'Статус',
    {
      searchable: false,
      renderMenuItem: (label, item) => (
        <Tag key={item?.value} color={item?.color}>
          {label}
        </Tag>
      )
    }
  ),
  createFilter.dateRange('activeFrom', 'Активен с'),
  createFilter.dateRange('activeUntil', 'Активен до')
]

export default function BannersFilter ({
  onFilterChanged
}: BannersFilterProps) {
  const handleSearch = useCallback((state: BannersFiltersType) => {
    onFilterChanged(prepareBannersFilter(state))
  }, [ onFilterChanged ])

  return (
    <FilterPanel<BannersFiltersType>
      filters={filterConfig}
      defaultState={defaultFilter}
      onSearch={handleSearch}
    />
  )
}
